module.exports = __webpack_public_path__ + "assets/img/slogan-cf7486e9.png";